const WHATSAPP = {
  HEADING_TITLE: 'اتصال رایچت به واتساپ',
  HEADING_SUBTITLE:
    'با اتصال رایچت به واتساپ، به راحتی می‌توانید به تمام چت‌های مشتریان در شبکه‌های اجتماعی و وبسایت پاسخ دهید.',
  GUIDE_TITLE: 'برای راهنمایی بیشتر، لطفاً مراحل زیر را دنبال کنید:',
  STEP_ONE_TITLE: 'مرحله اول',
  STEP_ONE_DESCRIPTION:
    'انتخاب وبسایت: در داشبورد حاضر، وبسایت مورد نظر را از منوی سمت راست انتخاب کنید تا QR کد نمایش داده شود.',
  STEP_TWO_TITLE: 'مرحله دوم : (تنظیمات در واتساپ تلفن همراه )',
  STEP_TWO_DESCRIPTION:
    'پس از نمایش QR کد، با موبایل خود به واتساپ بروید و شماره مورد نظر را متصل کنید.',
  STEPS_FOLLOW_DESCRIPTION: 'مراحل زیر را باید در تلفن همراه خود انجام دهید',
  STEPS_FOLLOW_ITEM_1: 'وارد واتساپ شوید و روی سه نقطه بالا کلیک کنید.',
  STEPS_FOLLOW_ITEM_2: "به بخش 'Linked device' یا 'دستگاه‌های متصل' بروید.",
  STEPS_FOLLOW_ITEM_3: "روی دکمه سبز رنگ 'Link A Device' ضربه بزنید.",
  STEPS_FOLLOW_ITEM_4:
    'QR کد نمایش داده شده در داشبورد رایچت را با دوربین گوشی اسکن کنید.',
  AFTER_STEPS_MSG:
    'با اتمام این مراحل، اتصال واتساپ شما به رایچت فعال می‌شود و می‌توانید از سرویس استفاده کنید.',
  WEBSITE_NOT_CHOSEN_MSG:
    'برای اتصال به واتساپ لطفا یکی از وبسایت ها را انتخاب کنید',
  SCAN_RETRY_BTN_LABEL: 'اسکن مجدد',
  LOGOUT_BTN_LABEL: 'لاگ اوت',
  UPGRADE_TO_PREMIUM_MSG:
    'برای استفاده از این ویژگی لطفا پکیج خود را به پریمیوم ارتقا دهید.',
};

export default WHATSAPP;
